import actions from "./actions";

export default {
  namespaced: true,
  state: {},
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/order/index.js